/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ExchangeCurrencyDto } from '../models';
// @ts-ignore
import type { ExchangeCurrencyResponseDto } from '../models';
// @ts-ignore
import type { ExchangeRatesDto } from '../models';
// @ts-ignore
import type { ExchangeRatesResponseDto } from '../models';
/**
 * EXCHANGEApi - axios parameter creator
 * @export
 */
export const EXCHANGEApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Конвертация валюты
         * @param {ExchangeCurrencyDto} exchangeCurrencyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeControllerConvertCurrency: async (exchangeCurrencyDto: ExchangeCurrencyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exchangeCurrencyDto' is not null or undefined
            assertParamExists('exchangeControllerConvertCurrency', 'exchangeCurrencyDto', exchangeCurrencyDto)
            const localVarPath = `/exchange/convert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exchangeCurrencyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение курсов валют к целевой
         * @param {ExchangeRatesDto} exchangeRatesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeControllerGetRates: async (exchangeRatesDto: ExchangeRatesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exchangeRatesDto' is not null or undefined
            assertParamExists('exchangeControllerGetRates', 'exchangeRatesDto', exchangeRatesDto)
            const localVarPath = `/exchange/rates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exchangeRatesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EXCHANGEApi - functional programming interface
 * @export
 */
export const EXCHANGEApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EXCHANGEApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Конвертация валюты
         * @param {ExchangeCurrencyDto} exchangeCurrencyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeControllerConvertCurrency(exchangeCurrencyDto: ExchangeCurrencyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExchangeCurrencyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeControllerConvertCurrency(exchangeCurrencyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EXCHANGEApi.exchangeControllerConvertCurrency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение курсов валют к целевой
         * @param {ExchangeRatesDto} exchangeRatesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeControllerGetRates(exchangeRatesDto: ExchangeRatesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExchangeRatesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeControllerGetRates(exchangeRatesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EXCHANGEApi.exchangeControllerGetRates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EXCHANGEApi - factory interface
 * @export
 */
export const EXCHANGEApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EXCHANGEApiFp(configuration)
    return {
        /**
         * 
         * @summary Конвертация валюты
         * @param {ExchangeCurrencyDto} exchangeCurrencyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeControllerConvertCurrency(exchangeCurrencyDto: ExchangeCurrencyDto, options?: RawAxiosRequestConfig): AxiosPromise<ExchangeCurrencyResponseDto> {
            return localVarFp.exchangeControllerConvertCurrency(exchangeCurrencyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение курсов валют к целевой
         * @param {ExchangeRatesDto} exchangeRatesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeControllerGetRates(exchangeRatesDto: ExchangeRatesDto, options?: RawAxiosRequestConfig): AxiosPromise<ExchangeRatesResponseDto> {
            return localVarFp.exchangeControllerGetRates(exchangeRatesDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EXCHANGEApi - object-oriented interface
 * @export
 * @class EXCHANGEApi
 * @extends {BaseAPI}
 */
export class EXCHANGEApi extends BaseAPI {
    /**
     * 
     * @summary Конвертация валюты
     * @param {ExchangeCurrencyDto} exchangeCurrencyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EXCHANGEApi
     */
    public exchangeControllerConvertCurrency(exchangeCurrencyDto: ExchangeCurrencyDto, options?: RawAxiosRequestConfig) {
        return EXCHANGEApiFp(this.configuration).exchangeControllerConvertCurrency(exchangeCurrencyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение курсов валют к целевой
     * @param {ExchangeRatesDto} exchangeRatesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EXCHANGEApi
     */
    public exchangeControllerGetRates(exchangeRatesDto: ExchangeRatesDto, options?: RawAxiosRequestConfig) {
        return EXCHANGEApiFp(this.configuration).exchangeControllerGetRates(exchangeRatesDto, options).then((request) => request(this.axios, this.basePath));
    }
}

